import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'
import Cache from './cache.js'
import Accounts from './accounts.js'
import AutoAccounts from './auto-accounts.js'
import AppStates from './app-states.js'
import FloatingCenters from './floating-centers'
import FloatingCenterCategories from './floating-center-category'
import AppContext from './app-context'
import Forms from './forms'
import Clipboard from './clipboard'
import banks from './banks'
import UserAccounts from './useraccount'
import Currencies from './currencies'
import Properties from './properties'
import ProductFloatings from './product-floatings'
import Warehouses from './warehouses'
import FiscalPeriods from './fiscal-periods.js'
import ClientPrint from './client-print'
import FrequentDescriptions from './frequent-descriptions'
import ChangeLog from './change-log'
import MetaData from './meta-data'
import ConcurrentRequests from './concurrent-requests'
import ProductPriceLevels from './product-price-levels'
import ProductMeasureUnits from './product-measure-units'
import ProductGroups from './product-groups'
import ProductPriceGroups from './product-price-groups'
import FormCodes from './form-codes'
import Socket from './socket'
import ProductClassifications from './product-classifications'
import FactorBunches from './factor-bunches.js'
import QueryDesigner from './query-designer.js'
import OnlineUsers from './onlineUsers'
import Notifications from './notification'
import TabHistory from './tab-history'
import Workshops from './workshops'
import SalaryPeriods from './salary-periods'
import HardLoading from './hard-loading'
import { markRaw } from 'vue'
import _ from 'lodash'


const vuexLocal = new VuexPersistence({
  key: 'nikan-data',
  storage: window.localStorage,
  modules: ['cache', 'currencies', 'i18n', 'properties', 'productFloatings', 'AppStates']
})

const vuexLocalAppStates = new VuexPersistence({
  key: 'nikan-app-states',
  storage: window.localStorage,
  modules: ['appStates']
})

const vuexLocalUser = new VuexPersistence({
  key: 'nikan-user',
  storage: window.localStorage,
  modules: ['useraccount']
})

// TYPES
const MODAL_SHOW = 'MODAL.SHOW'
const MODAL_CLOSE = 'MODAL.CLOSE'
const UID = 'GLOBAL.UID'
const DIALOG_SHOW = 'DIALOG.SHOW'
const DIALOG_CLOSE = 'DIALOG.CLOSE'
const DIALOG_CLOSE_All = 'DIALOG.CLOSEAll'
const MODAL_CLOSE_All = 'MODAL.CLOSEALL'
const MENU_SOW = 'MENU.SHOW'

// STATE
const state = {
  modals: [],
  messages: [],
  lastId: 0,
  menuStatus: true,
}

// MUTATIONS
const mutations = {
  [MENU_SOW](state, status) {
    state.menuStatus = status
  },
  [MODAL_SHOW](state, modal) {
    state.modals.push(modal)
  },
  [MODAL_CLOSE](state) {
    state.modals.pop()
  },
  [UID](state) {
    state.lastId += 1
  },
  [DIALOG_SHOW](state, message) {
    state.messages.push(message)
  },
  [DIALOG_CLOSE](state) {
    state.messages.shift()
  },
  [DIALOG_CLOSE_All](state) {
    state.messages = []
  },
  [MODAL_CLOSE_All](state) {
    state.modals = []
  }
}

// ACTIONS
const actions = ({
  hide_show({ commit }, status) {
    commit(MENU_SOW, status)
  },
  addModal({ commit, state }, modal) {
    let uniqueUIDS = state.modals.map(x => x.component.modal.stateUID)
    const sameModals = uniqueUIDS.filter(x => x.split('@')[0] === modal.component.modal.stateUID)

    if (sameModals.length > 0) {
      const newModal = _.cloneDeep(modal)
      newModal.component.modal.stateUID = `${modal.component.modal.stateUID}@${sameModals.length + 1}`
      newModal.component = markRaw(newModal.component)
      commit(MODAL_SHOW, newModal)
    } else {
      commit(MODAL_SHOW, modal)
    }
  },
  removeModal({ commit }) {
    commit(MODAL_CLOSE)
  },
  incrementUID({ commit, state }, callback) {
    commit(UID)
    if (callback) {
      callback(state.lastId)
    }
  },
  addMessage({ commit }, message) {
    commit(DIALOG_SHOW, message)
  },
  removeMessage({ commit }) {
    commit(DIALOG_CLOSE)
  },
  removeAllMessage({ commit }) {
    commit(DIALOG_CLOSE_All)
  },
  removeAllModals({ commit }) {
    commit(MODAL_CLOSE_All)
  }
})

const getters = {
  menuStatus: state => {
    return state.menuStatus
  },
}

const modules = {
  cache: Cache,
  accounts: Accounts,
  autoAccounts: AutoAccounts,
  appStates: AppStates,
  floatingCenters: FloatingCenters,
  forms: Forms,
  appContext: AppContext,
  clipboard: Clipboard,
  floatingCenterCategories: FloatingCenterCategories,
  banks: banks,
  useraccount: UserAccounts,
  currencies: Currencies,
  properties: Properties,
  productFloatings: ProductFloatings,
  warehouses: Warehouses,
  fiscalPeriods: FiscalPeriods,
  clientprint: ClientPrint,
  frequentdescriptions: FrequentDescriptions,
  changelog: ChangeLog,
  metadata: MetaData,
  concurrentRequests: ConcurrentRequests,
  productPriceLevels: ProductPriceLevels,
  productMeasureUnits: ProductMeasureUnits,
  productGroups: ProductGroups,
  productPriceGroups: ProductPriceGroups,
  formCodes: FormCodes,
  socket: Socket,
  productClassifications: ProductClassifications,
  factorBunches: FactorBunches,
  queryDesigner: QueryDesigner,
  onlineUsers: OnlineUsers,
  notifications: Notifications,
  tabHistory: TabHistory,
  workshops: Workshops,
  salaryPeriods: SalaryPeriods,
  hardLoading: HardLoading
}

const Store = createStore({
  state,
  mutations,
  actions,
  modules,
  getters,
  plugins: [vuexLocal.plugin, vuexLocalUser.plugin, vuexLocalAppStates.plugin]
})

export default Store
